import useViewport from "../../../Utilities/useViewport";
import TabNav from "./TabNav";
import useTeacherNavStore from "../../../stores/useTeacherNavStore";
import { GetPeriods, GetUnviewedWorkRegistrationCountsByPeriod } from "../../../actions/teacherQueries";

export default function TabNavSelector(props) {
  const { width } = useViewport();
  const breakpoint = 620;
  const isMobile = width < breakpoint;

  const tab = useTeacherNavStore((state) => state.tab);
  const setTab = useTeacherNavStore((state) => state.setTab);
  const handlePostNavTab = (tabNr) => {
    setTab(tabNr);
  };

  const capitalizedLevel = props.level.charAt(0).toUpperCase() + props.level.slice(1);
  const periodsData = GetPeriods(capitalizedLevel, Number(props.objId));
  const { data: unviewedCountsByPeriod } = GetUnviewedWorkRegistrationCountsByPeriod();

  const aplUnviewedCount = (unviewedCountsByPeriod && periodsData.data)
    ? periodsData.data.reduce((sum, p) => sum + (unviewedCountsByPeriod[p.period.id] || 0), 0)
    : 0;

  const NavTabsOnlyInClass = [5, 6];
  if (props.level !== "class" && NavTabsOnlyInClass.includes(tab)) {
    handlePostNavTab(1);
  }
  return (
    <TabNav
      level={props.level}
      handlePostNavTab={handlePostNavTab}
      tab={tab}
      isMobile={isMobile}
      aplUnviewedCount={aplUnviewedCount}
    />
  );
}
